<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container design-wrapper">
  <h2>Designs</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li routerLink="/home" class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a routerLink="/design" class="breadcrumb__list__list-item__link">Copy Design</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a  class="breadcrumb__list__list-item__link">Copy Systems</a>
      </li>
    </ul>
  </div>

  <div class="d-flex justify-content-start">
    <h3 class="textConfirmation">The systems below will be copied. </h3>
  </div>
  <div class="d-flex justify-content-start">
    <button mat-flat-button color="primary" class="add-new-btn" [routerLink]="['/design']" (click)="copySystems()">
      <mat-icon>done</mat-icon>
      Confirm
    </button>

    <button mat-flat-button color="primary" class="add-new-btn" style="background:#ff7575 !important; margin-left:20px;" [routerLink]="['/design']" >
      <mat-icon>X</mat-icon>
      Don't Copy Systems
    </button>
  </div>

  <div class="row">
    <div class="design-wrapper__item col-md-4 col-12 px-3" *ngFor="let design of designs">
      <mat-card class="w-100 d-flex flex-column">
        <div class="flex-grow-1 flex-column d-flex">
          <h2 class="design-wrapper__item__title">{{ design.name }}</h2>
          <p class="design-wrapper__item__detail">ID: {{ design.selection_id }}</p>
        </div>
      </mat-card>
    </div>
  </div>

</div>
